let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bKLJ9")).then(() => parcelRequire('9S4eI'));